import { useLocation } from 'react-router-dom';

import ROUTES from '@/common/routes';
import { ORG_LOCK_BANNER_HEIGHT } from '@/modules/core/components/OrgLockBanner/OrgLockBanner.constants';
import useEmployerTerminationBanner from '@/modules/core/hooks/useEmployerTerminationBanner';
import useShowLockBanner from '@/modules/core/hooks/useShowLockBanner';
import { useUnappliedFundsHomeBannerStore } from '@/modules/UnappliedFundsBanner/stores';
import { UNAPPLIED_FUNDS_HOME_BANNER_HEIGHT } from '@/modules/UnappliedFundsBanner/UnappliedFundsBanner.constants';

const useTopBannersOffset = () => {
  const { pathname } = useLocation();
  const isLockBannerShowed = useShowLockBanner();
  const { bannerHeight } = useEmployerTerminationBanner();
  const isHomeBannerVisible = useUnappliedFundsHomeBannerStore((state) => state.isVisible);

  const topBannersHeight = isLockBannerShowed ? ORG_LOCK_BANNER_HEIGHT : bannerHeight || '0px';
  const homeBannerHeight = isHomeBannerVisible && pathname === ROUTES.HOME ? UNAPPLIED_FUNDS_HOME_BANNER_HEIGHT : '0px';

  return { topBannersHeight, contentOffset: `calc(${topBannersHeight} + ${homeBannerHeight})` };
};

export default useTopBannersOffset;
